import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Paper, Box, TextField, IconButton, Snackbar, Alert, Dialog, DialogTitle, DialogContent} from '@mui/material';
import { Tooltip as MuiTooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useRef } from "react";
import Draggable from 'react-draggable';
import img from "../../assets/img/spinner.svg";

// Iconos
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// Iconos
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import CrearEditarModal from './modales/CrearEditarArgui';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import CompareIcon from '@mui/icons-material/Compare';
import DeleteIcon from '@mui/icons-material/Delete';

import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule } from 'ag-grid-community';

const Cargas_Arguen = () => {
    const gridRef = useRef();
    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleOpenModal = (carga = null) => {
        setSelected(carga);
        setIsEditing(!!carga);
        setModalOpen(true);
    };

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState(''); // Estado para el campo "Unidad"
    const [startDate, setStartDate] = useState(null); // Estado para la fecha inicial
    const [endDate, setEndDate] = useState(null); // Estado para la fecha final

    // Maneja los cambios en el campo "Unidad"
    const handleChangeUnidad = (event) => {
        setUnit(event.target.value);
    };

    // Maneja los cambios en la fecha de inicio
    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        // Si la fecha final ya está establecida y es menor a la fecha inicial, la actualizamos
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha inicial.',
            }).then(() => {
                setEndDate(newValue);
            }); 
                // Establecer la fecha final igual a la fecha inicial
        }
    };

    // Maneja los cambios en la fecha de fin
    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => {
                setEndDate(startDate);
            }); 
        }
    };

    // Handler para vaciar la fecha al hacer clic
    const handleClearDate = (fecha) => {
        if(fecha === 'fi')
            setStartDate(null); 
        else if (fecha === 'ff')
            setEndDate(null); 
    };

    //Función para formatear la fecha
    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    
    const handleOpenSnackbar = () => setSnackbarOpen(true);
    const handleCloseSnackbar = (event, reason) => {
      if (reason === 'clickaway') return;
      setSnackbarOpen(false);
    };

    const columns = [
/*         {
            field: "copy",
            headerName: "",
            width: 10,
            disableColumnMenu: true,
            disableExport: true,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => {
                const handleCopy = () => {
                    const rowString = getFormattedRowString(params); 
                    navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar(); 
                    });
                };

                return (
                    <MuiTooltip title="Copiar renglón">
                        <IconButton onClick={handleCopy} color="primary">
                            <ContentCopyIcon />
                        </IconButton>
                    </MuiTooltip>
                );
            },
        }, */
/*         {
            headerName: "",
            field: "copy",
            width: 50,
            pinned: true,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const handleCopy = () => {
                const rowString = getFormattedRowString(params.data);
                navigator.clipboard.writeText(rowString).then(() => {
                    handleOpenSnackbar();
                });
                };

                return (
                <MuiTooltip title="Copiar renglón">
                    <IconButton onClick={handleCopy} color="primary" size="small">
                    <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </MuiTooltip>
                );
            },
        }, */
        { field: 'occurred', headerName: 'Occurred',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
            valueFormatter: (params) => formatDate(params.value),
            pinned: true
        },
        { field: 'vehicle', headerName: 'Vehicle',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
            pinned: true
        },
        { field: 'department', headerName: 'Department',
            cellStyle: { textAlign: "center" },
            minWidth: 150
        },
        { field: 'vehicle_desc', headerName: 'Vehicle Description',
            cellStyle: { textAlign: "center" },
            minWidth: 150
        },
/*         { field: 'meter', headerName: 'Meter',
            cellStyle: { textAlign: "center" },
            minWidth: 150
        }, */
        { field: 'driver', headerName: 'Driver',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
        },
        { field: 'first_name', headerName: 'First Name',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
        },
        { field: 'last_name', headerName: 'Last Name',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
        },
        { field: 'tank', headerName: 'Tank',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
        },
        { field: 'product', headerName: 'Product',
            cellStyle: { textAlign: "center" },
            minWidth: 150,
        },
        { field: 'quantity', headerName: 'Quantity',
            cellStyle: { textAlign: "right" },
            minWidth: 150,
            valueFormatter: (params) => 
            {
                if (!params.value) 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
        { field: 'unit_price', headerName: 'Unit Price',
           cellStyle: { textAlign: "right" },
            minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) 
                    return ''; 
                
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                
                if (isNaN(numericValue))
                    return params.value;  
                
                return `$${numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            }
        },
        { field: 'total_amount', headerName: 'Total Amount',
            cellStyle: { textAlign: "right" },
            minWidth: 150,
            valueFormatter: (params) => {
                if (!params.value) 
                    return ''; 
                
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                
                if (isNaN(numericValue))
                    return params.value;  
                
                return `$${numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            }
        },
        {
            headerName: "Actions",
            field: "actions",
            width: 150,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const row = params.data;

                if (row.isTotal) return null;

                if (row.isManual === "1") 
                {
                    return (
                        <div style={{ display: "flex", gap: 8 }}>
                            <BtnAcciones
                            icon={<BorderColorIcon />}
                            label="Editar"
                            onClick={() => handleEdit(row)}
                            />
                            <BtnAcciones
                            icon={<DeleteIcon />}
                            label="Eliminar"
                            onClick={() => handleDelete(row.auto_id)}
                            />
                        </div>
                    );
                }
            },
        }
    ];

    const handleEdit = useCallback(async (fuelRow) => {
        handleOpenModal(data.find(carga => carga.auto_id === fuelRow.auto_id));
        setIsEditing(true);
        setSelected(fuelRow);
        
    }, []);

    const handleDelete = useCallback(async (id) => {
        try {
            Swal.fire({
                title: '¿Está seguro de eliminar esta carga?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/deleteArgui/${id}`);

                    if (data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Carga eliminada',
                        });

                        setData(prevData => prevData.filter(carga => carga.auto_id !== id));
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar la carga',
                        });
                    }
                }
            });
            
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const fetch = async (unidad = null, fi = null, ff = null) => 
    {
        setLoading(true);
        try 
        {
            const datosEnviados = { unidad, fi, ff };
            const response = await myApi.post('/cargasFuel/getArgue', datosEnviados);
            console.log(response)
            if(response.data.success)
                setData(response.data.data);
            else
                setData([]);
        } 
        catch(error) 
        {
            console.error('Error fetching fuel loads:', error);
        }
        finally 
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleSubmit = async (e) => 
    {
        //e.preventDefault();
        let fechainicial = null, fechafinal = null, unidad = null;
        if (startDate && startDate.$d!='Invalid Date')
            fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d!='Invalid Date')
            fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit != 'undefined' && unit != '')
            unidad = unit;
        // Llamamos a fetchData para cargar los datos
        await fetch(unidad, fechainicial, fechafinal);
    };

    const totalsRow = React.useMemo(() => {
        const sum = (field) =>
            data.reduce((acc, row) => acc + (Number(row[field]) || 0), 0);

        const avg = (field) => {
            const valid = data.filter(r => Number(r[field]));
            if (!valid.length) return 0;
            return sum(field) / valid.length;
        };

        return {
            id: 'totals',
            vehicle: 'TOTAL',
            isTotal: true, 
            quantity: sum('quantity'),
            unit_price: avg('unit_price'), 
            total_amount: sum('total_amount'),
        };
    }, [data]);

    return (
    <>
        <Paper
            sx={{
                p: 2,
                height: "calc(100vh - 125px)",
                width: "100%",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
            }}
        >
            {/* ENCABEZADO Y FILTROS */}
            <Box sx={{ flexShrink: 0 }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <Typography variant="h4" fontWeight="bold">
                            Cargas de Tower
                        </Typography>

                        <Button
                            variant="contained"
                            startIcon={<AddCircleIcon />}
                            onClick={() => handleOpenModal()}
                            sx={{ backgroundColor: 'black' }}
                        >
                            Agregar
                        </Button>
                    </Box>

                    <Grid container spacing={2} alignItems="center">
                        {/* Campo de Unidad */}
                        <Grid size={{ xs: 12, sm: 3 }}>
                            <TextField
                                label="Unidad"
                                variant="outlined"
                                value={unit}
                                onChange={handleChangeUnidad}
                                fullWidth
                            />
                        </Grid>

                        {/* Campo de Fecha Inicial */}
                        <Grid size={{ xs: 12, sm: 3 }} sx={{ display: 'flex', alignItems: 'center' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={startDate}
                                    onChange={handleChangeStartDate}
                                    format="MM/DD/YY"
                                    label="Fecha Inicial"
                                    slotProps={{ textField: { fullWidth: true } }}
                                />
                            </LocalizationProvider>
                            <IconButton onClick={() => handleClearDate('fi')} aria-label="clear">
                                <ClearIcon />
                            </IconButton>
                        </Grid>

                        {/* Campo de Fecha Final */}
                        <Grid size={{ xs: 12, sm: 3 }} sx={{ display: 'flex', alignItems: 'center' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={endDate}
                                    onChange={handleChangeEndDate}
                                    format="MM/DD/YY"
                                    label="Fecha Final"
                                    slotProps={{ textField: { fullWidth: true } }}
                                />
                            </LocalizationProvider>
                            <IconButton onClick={() => handleClearDate('ff')} aria-label="clear">
                                <ClearIcon />
                            </IconButton>
                        </Grid>

                        {/* Botón de Buscar */}
                        <Grid size={{ xs: 12, sm: 3 }}>
                            <Button
                                type="button"
                                color="inherit"
                                onClick={handleSubmit}
                                variant="contained"
                                startIcon={<ManageSearchIcon />}
                                sx={{ color: "primary", fontWeight: "bold" }}
                            >
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>

            {/* SECCIÓN DE LA TABLA AG-GRID */}
            <Box sx={{ flex: 1, minHeight: 0, mt: 2, display: "flex", flexDirection: "column" }}>
                {loading ? (
                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            alt="Cargando..."
                            width="200px"
                            height="200px"
                            src={img}
                            style={{ cursor: "pointer", borderRadius: "50%" }}
                        />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ flexShrink: 0, mb: 1 }}>
                            <Button 
                                variant="contained" 
                                onClick={() => gridRef.current?.api?.exportDataAsCsv()}
                            >
                                Exportar a Excel
                            </Button>
                        </Box>

                        <Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
                            <div 
                                className="ag-theme-quartz" 
                                style={{ 
                                    height: "100%", 
                                    width: "100%" 
                                }}
                            >
                                <AgGridReact
                                    modules={[AllCommunityModule]}
                                    ref={gridRef}
                                    rowData={data}
                                    columnDefs={columns}
                                    pagination={true}
                                    pinnedBottomRowData={[totalsRow]}
                                    getRowId={params => params.data.auto_id}
                                    autoSizeStrategy={{
                                        type: 'fitCellContents',
                                        skipHeader: true
                                    }}
                                />
                            </div>
                        </Box>
                    </>
                )}
            </Box>
        </Paper>
        {/* {MODAL CREAR/EDITAR CARGA MANUAL} */}
        <CrearEditarModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            refresh={fetch}
            carga={selected}
            isEditing={isEditing}
        />
        <Snackbar
            open={snackbarOpen}
            autoHideDuration={2000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                Texto copiado al portapapeles ✅
            </Alert>
        </Snackbar>
    </>
    )

}

export default Cargas_Arguen